import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppBusyStateComponentDef } from '@df/ui/display/busy-state/app-busy-state.component.def';

@Component({
    selector: 'app-busy-state',
    templateUrl: './app-busy-state.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppBusyStateComponent extends AppBusyStateComponentDef {}
